import * as React from 'react';

import { ListDescription, ParagraphDescription } from './components';
import { TDescription, EDescriptionType } from '../../../../types/mortgage';

interface IDescriptionProps {
  description: TDescription;
}

export const MortgageProgramDescription: React.FC<IDescriptionProps> = ({ description }) => {
  return (
    <>
      {description.type === EDescriptionType.LIST && <ListDescription list={description.value} />}
      {description.type === EDescriptionType.PARAGRAPH && <ParagraphDescription text={description.value} />}
    </>
  );
};
